import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ListLoader from "../../../CustomComponents/AllLoader/ListLoader";
import OrderPostPagination from "../../FindWork/SearchAll/AllPosts/CustomPagination/OrderPostPagination";
import { getRemaindays } from "../../../Common/AllDateTimeReleventFormate";
import { getMyOrderProjectList } from "../../../../redux/project/action";
import GetRemainDays from "../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetRemainDays";
import GetStatus from "../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetStatus";
import { getMyOrderUmbrellaProjectList } from "../../../../redux/umbrella/action";
import CustomeCircularProgressbar from "../../../Common/CustomeLabel/CustomeCircularProgressbar";
import { getPercentage } from "../../../Common/FewCommonMethods";

export default function PaginationforUmbrallaProjectCompleted() {
  const path = "Assets/scss/myorders.module.scss";
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const myorderprojectlist = useSelector(
    ({ umbrella: { myorderumbrellaprojectlist } }) =>
      myorderumbrellaprojectlist,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMyOrderUmbrellaProjectList(1, pageNumber, 10, 3));
  }, [pageNumber]);

  return (
    <div className="order-tabs">
      <div className="tab-content">
        <div className="posted-project">
          {Array.isArray(myorderprojectlist?.response) && (
            <>
              <h4>
                Completed Post & Browse Projects (PBP)
                <OrderPostPagination
                  totalitemcounts={myorderprojectlist?.count}
                  size={10}
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                />
              </h4>
              {myorderprojectlist?.length == 0 && <ListLoader />}
              <div className="recent-post">
                {myorderprojectlist?.response.map((item, index) => (
                  <div key={index} className="post-back">
                    <div className="col-md-2 col-6 mx-auto">
                      <CustomeCircularProgressbar
                        percentage={getPercentage(
                          item?.total_milestone,
                          item?.completed_milestone,
                        )}
                      />
                    </div>
                    <div className="col padding-zero">
                      <h6>{item?.ambrella_title}</h6>
                      <div className="table-responsive">
                        <table className="table">
                          <thead>
                            <th>Milestone completed </th>
                            <th>Completed sub projects</th>
                            <th>Hired Experts</th>
                            <th>Total cost</th>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{item?.completed_milestone} out of {item?.total_milestone}</td>
                              <td>{item?.completed_sub_projects || 0}</td>
                              <td>{item?.hired_experts || 0}</td>
                              <td>$ {item?.total_price || 0}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <button
                      onClick={() =>
                        navigate(
                          `/${lan}/dashboard/myorders/umrellaproject/${item.id}`,
                        )
                      }
                      className="btn"
                    >
                      View details
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                        alt=""
                      />
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
